import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import { decimalInvertedReportFormatter } from "../../fomatters/DecimalFormatter";
import GroupedReport from "../GroupedReport";
import InputSelect from "../InputSelect";
import SubGroup from "../SubGroup";

const startDateValue = new Date().toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function AgentHoldPercent() {
  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [agentFrom, setAgentFrom] = useState("");
  const onAgentFromChange = useCallback(
    (event) => setAgentFrom(event.target.value),
    []
  );

  const [agentTo, setAgentTo] = useState("");
  const onAgenToChange = useCallback(
    (event) => setAgentTo(event.target.value),
    []
  );

  const [groupBy, setGroupBy] = useState(0);
  const onGroupByChange = useCallback(
    (event) => setGroupBy(Number(event.target.value)),
    []
  );

  const [distributor, setDistributor] = useState("");
  const onDistributorChanged = useCallback(
    (event) => setDistributor(event.target.value),
    []
  );

  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  const [group, setGroup] = useState("");
  const onGroupChanged = useCallback((g) => setGroup(g), []);
  const { values: groups } = useDataFormatterHook({
    addEmpty: true,
    value: "groupName",
    text: "groupName",
    path: `/Player/Grouping_GetList`,
  });

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          className="flex-1"
          required
          variant="outlined"
          id="gameDateTime"
          label="From"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          id="gameDateTime"
          label="To"
          type="date"
          value={endDate}
          size="small"
          onChange={onEndDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent From"
          type="text"
          value={agentFrom}
          size="small"
          onChange={onAgentFromChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent To"
          type="text"
          value={agentTo}
          size="small"
          onChange={onAgenToChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Group"
          name="name"
          data={groups}
          placeholder="DataFormatter"
          setSelectValue={onGroupChanged}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Distributor"
          type="text"
          value={distributor}
          size="small"
          onChange={onDistributorChanged}
          InputLabelProps={{ shrink: true }}
        />

        <div>
          <SubGroup title="Order By">
            <FormControl component="fieldset">
              <RadioGroup label value={groupBy} onChange={onGroupByChange} row>
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Sport"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Period"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Bet Type"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={3} size="small" color="primary" />}
                  label="Play"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
      </div>
      <GroupedReport
        title="Agent Hold Percent Report"
        getUrl={() => "/Reports/Report_Agent_Hold_Percent"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          EndDate: endDate,
          AgentFrom: agentFrom,
          AgentTo: agentTo,
          Book: book,
          Group: group,
          GroupBy: groupBy,
          Distributor: distributor,
        })}
        getProcess={(item) => ({
          ...item,
          holdPercentage: `${Math.round((item.winLost / item.amount + Number.EPSILON) * 10000) /
            100
            }%`,
        })}
        getTotals={(data) => {
          const amount = data.reduce((acc, item) => acc + item.amount, 0);
          const winLost = data.reduce((acc, item) => acc + item.winLost, 0);

          return {
            group4: "SubTotal",
            amount,
            winLost,
            holdPercentage: `${Math.round((winLost / amount + Number.EPSILON) * 10000) / 100
              }%`,
          };
        }}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="group3">
          Period
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="group4">
          Play
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="amount"
          dataFormat={decimalInvertedReportFormatter}
        >
          Risked
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="winLost"
          dataFormat={decimalInvertedReportFormatter}
        >
          Win / Loss
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="holdPercentage">
          HoldPct
        </TableHeaderColumn>
      </GroupedReport>
    </div>
  );
}

export default AgentHoldPercent;
